import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {FlexboxGrid, Col, Grid, Icon, Panel} from 'rsuite';
import {Image } from 'react-bootstrap';

class BasicPlan extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);

		this.state = {
		}
	}

	componentDidMount(){
	}

	handleChange(e){
	}

	render(){
		const {t} = this.props;
		return (
            <Panel className="panel-general basic" bordered shaded={this.props.basic} style={{height: 640, cursor:'pointer'}} onClick={()=>this.props.changePlan('basic')}>
				<div style={{textAlign:'center'}}>
					<Image className="image-plan" src="images/plans/basic.svg" style={{width:'100%'}} />
					
					<div className="title-plan">
						<span>{t('screen.plans.basic')}</span>
					</div>
				</div>
								
				<FlexboxGrid justify="center">
					<Col xs={24}>
						<Grid fluid>
							<Col xs={24} style={{textAlign:"right"}}>
								<span style={{fontWeight:'bold', display:'block', fontSize:'2.8em'}}>$0.99 USD</span>
								
							</Col>
							<Col xs={24} style={{textAlign:"right"}}>
								<span style={{fontWeight:'bold', fontSize:'1em', display:'block'}}>
									{t('screen.plans.periodicity')}
								</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.facial')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.location')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.unlimited_check')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.unlimited_employees')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>10 {t('screen.plans.address2')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.standard_report')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.special_report')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.multi_checks')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.overtime')}</span>
							</Col>
							<Col xs={24}>
								<Icon icon="check" style={{color:'green', marginRight:8}} /> <span>{t('screen.plans.special_configuration')}</span>
							</Col>
						</Grid>
					</Col>
				</FlexboxGrid>
				
				<div className="footer-plan" style={{background:'#3f7bff'}}></div>
		    </Panel>
		)
	}
		  
}

export default withTranslation('translations')(BasicPlan)